// the underscore-formatted variables are replaced in source code by webpack's DefinePlugin,
// in webpack.config.js

// we use this named-constant approach instead of directly accessing process.env
// in application code to prevent accidental name mismatches, leading to null values
// and resulting bugs in production
// example bug: https://app.shortcut.com/guild/story/279323/fix-sponsorship-apply-url

// to add a new configuration value:
// * add a var declaration and a named constant to this file
// * add an entry to the DefinePlugin in webpack.config.js
// * add an entry into each .env file (don't forget the one in 1Password for local development)
// * add an entry in the globals object in jest.config.js

declare const __ALGOLIA_API_KEY__: string;
declare const __ALGOLIA_APPLICATION_ID__: string;
declare const __ALGOLIA_ENV__: string;
declare const __APP_SYNC_ENDPOINT__: string;
declare const __APPLICATIONS_URL__: string;
declare const __AUTH0_CLIENT_ID__: string;
declare const __AUTH0_DOMAIN__: string;
declare const __BENEFITS_SPONSORSHIP_URL__: string;
declare const __BENEFITS_URL__: string;
declare const __CATALOG_SERVICE_URL__: string;
declare const __CATALOG_URL__: string;
declare const __CONTACT_SUPPORT_URL__: string;
declare const __DATADOG_ENV__: string;
declare const __DATADOG_RUM_APPLICATION_ID__: string;
declare const __DATADOG_RUM_CLIENT_TOKEN__: string;
declare const __GENESIS_APPLY_URL__: string;
declare const __GITHUB_SHA__: string;
declare const __GUILD_DOMAIN__: string;
declare const __GUILD_GLOBAL_API_URL__: string;
declare const __GUILD_URL__: string;
declare const __HELP_CENTER_URL__: string;
declare const __HOME_URL__: string;
declare const __MAPBOX_ACCESS_TOKEN__: string;
declare const __MAPBOX_URL__: string;
declare const __OPTIMIZELY_BASE_URL__: string;
declare const __OPTIMIZELY_SDK_KEY__: string;
declare const __OPTIMIZELY_X_ENV__: string;
declare const __PUBLIC_PATH__: string;
declare const __ROLLBAR_ENV__: string;
declare const __ROLLBAR_POST_CLIENT_TOKEN__: string;
declare const __SEGMENT_KEY__: string;
declare const __SEGMENT_PROXY_URL__: string;
declare const __SPONSORSHIP_URL__: string;
declare const __TUITION_REIMBURSEMENT_URL__: string;

export const ALGOLIA_API_KEY = __ALGOLIA_API_KEY__;
export const ALGOLIA_APPLICATION_ID = __ALGOLIA_APPLICATION_ID__;
export const ALGOLIA_ENV = __ALGOLIA_ENV__;
export const APP_SYNC_ENDPOINT = __APP_SYNC_ENDPOINT__;
export const APPLICATIONS_URL = __APPLICATIONS_URL__;
export const AUTH0_CLIENT_ID = __AUTH0_CLIENT_ID__;
export const AUTH0_DOMAIN = __AUTH0_DOMAIN__;
export const BENEFITS_SPONSORSHIP_URL = __BENEFITS_SPONSORSHIP_URL__;
export const BENEFITS_URL = __BENEFITS_URL__;
export const CATALOG_SERVICE_URL = __CATALOG_SERVICE_URL__;
export const CATALOG_URL = __CATALOG_URL__;
export const CONTACT_SUPPORT_URL = __CONTACT_SUPPORT_URL__;
export const DATADOG_ENV = __DATADOG_ENV__;
export const DATADOG_RUM_APPLICATION_ID = __DATADOG_RUM_APPLICATION_ID__;
export const DATADOG_RUM_CLIENT_TOKEN = __DATADOG_RUM_CLIENT_TOKEN__;
export const GENESIS_APPLY_URL = __GENESIS_APPLY_URL__;
export const GITHUB_SHA = __GITHUB_SHA__;
export const GUILD_DOMAIN = __GUILD_DOMAIN__;
export const GUILD_GLOBAL_API_URL = __GUILD_GLOBAL_API_URL__;
export const GUILD_URL = __GUILD_URL__;
export const HELP_CENTER_URL = __HELP_CENTER_URL__;
export const HOME_URL = __HOME_URL__;
export const MAPBOX_ACCESS_TOKEN = __MAPBOX_ACCESS_TOKEN__;
export const MAPBOX_URL = __MAPBOX_URL__;
export const OPTIMIZELY_BASE_URL = __OPTIMIZELY_BASE_URL__;
export const OPTIMIZELY_SDK_KEY = __OPTIMIZELY_SDK_KEY__;
export const OPTIMIZELY_X_ENV = __OPTIMIZELY_X_ENV__;
export const PUBLIC_PATH = __PUBLIC_PATH__;
export const ROLLBAR_ENV = __ROLLBAR_ENV__;
export const ROLLBAR_POST_CLIENT_TOKEN = __ROLLBAR_POST_CLIENT_TOKEN__;
export const SEGMENT_KEY = __SEGMENT_KEY__;
export const SEGMENT_PROXY_URL = __SEGMENT_PROXY_URL__;
export const SPONSORSHIP_URL = __SPONSORSHIP_URL__;
export const TUITION_REIMBURSEMENT_URL = __TUITION_REIMBURSEMENT_URL__;
